<template>  
  <SimpleFrame msg="Start external course (MEGA beta)"/>
</template>

<script>
import SimpleFrame from './components/SimpleFrame.vue'

export default {
  name: 'App',
  components: {
    SimpleFrame
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  background-color: #efefef;
}
</style>
